import { useRect } from '#hooks/useRect.ts';
import { useAnimatedTabs } from '../context/useAnimatedTabs.tsx';
import styles from './ActiveTabIndicator.module.css';

type Props<T extends Element | null> = {
  tabsRef: React.RefObject<T>;
};

export function ActiveTabIndicator<T extends Element | null>({ tabsRef }: Props<T>) {
  // eslint-disable-next-line react-hooks/refs
  const rect = useRect(tabsRef, { observe: Boolean(tabsRef.current) });
  const { activeRect } = useAnimatedTabs();

  if (!activeRect || !rect) return null;

  return (
    <div
      className={styles.ActiveTabIndicator}
      style={{
        left: activeRect.left - rect.left,
        top: activeRect.bottom - rect.top,
        width: activeRect.width,
      }}
    />
  );
}
